"use client";

import { useState } from "react";

import type { CalendarCriteriaInput } from "#app/_ui/components/market-research/criteria-builder";
import { Button } from "#ui/button";
import { Icon } from "#ui/icon";

import { CalendarEventDetail } from "./calendar-event-detail";
import {
  CalendarEventsList,
  type CalendarItemClickEvent,
} from "./calendar-events-list";

export function Calendar({ criteria }: { criteria: CalendarCriteriaInput }) {
  const [calendarEventId, setCalendarEventId] = useState<string | null>(null);

  if (calendarEventId) {
    return (
      <div className="mx-auto block max-w-655px space-y-20px">
        <Button
          onClick={() => {
            setCalendarEventId(null);
          }}
          size="sm"
          variant="outline"
          palette="neutral"
        >
          <Icon name="ms-navigate-prev" />
          <span>Back To List</span>
        </Button>
        <CalendarEventDetail identifier={calendarEventId} />
      </div>
    );
  }

  return (
    <CalendarEventsList
      onCalendarItemClick={(event: CalendarItemClickEvent) => {
        setCalendarEventId(event.detail[0].identifier);
      }}
      criteria={criteria}
    />
  );
}
